import React, { createContext, useState, useContext, useEffect } from 'react';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '../i18n/resolve';
import { featureVisibility } from '../config/featureVisibility';

const LanguageContext = createContext();

function resolveInitialLanguage() {
  const saved = localStorage.getItem('language');
  if (!featureVisibility.language.showEnglish) {
    return 'mr';
  }
  return SUPPORTED_LANGUAGES.includes(saved) ? saved : DEFAULT_LANGUAGE;
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(resolveInitialLanguage);

  const changeLanguage = (lang) => {
    if (!SUPPORTED_LANGUAGES.includes(lang)) return;
    if (!featureVisibility.language.showEnglish && lang === 'en') return;
    setLanguage(lang);
    localStorage.setItem('language', lang);
  };

  useEffect(() => {
    if (!featureVisibility.language.showEnglish && language === 'en') {
      setLanguage('mr');
      localStorage.setItem('language', 'mr');
    }
  }, [language]);

  useEffect(() => {
    document.documentElement.lang = language === 'mr' ? 'mr' : 'en';
  }, [language]);

  const value = {
    language,
    changeLanguage,
    isEnglish: language === 'en',
    isMarathi: language === 'mr',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
